import axios from 'axios'
const state = {
  dataTiktok: { labels: [], datasets: [] },
  dataTiktokMore: [],
}
const mutations = {
  setDataTiktok (state, data) {
    state.dataTiktok = data
  },
  setDataTiktokMore (state, data) {
    state.dataTiktokMore = data
  },
}
const actions = {
  getDataTiktok ({ commit }, credentials) {
    return axios
      .get(
        `https://api.feedpixel.com/v1/statistics/?start_date=${credentials.replace(
          ' to ',
          '&end_date=',
        )}`,
        {
          auth: {
            username: 'feedpixel',
            password: '8ek[}L"Q=;#h&SY]',
          },
        },
      )
      .then(({ data }) => {
        const res = { labels: [] }

        res.datasets = [
          { data: [], label: 'avg_time' },
          { data: [], label: 'failed', backgroundColor: '#ff000085' },
          { data: [], label: 'succeeded', backgroundColor: '#0080007a' },
        ]

        Object.entries(data.statistics_per_day).forEach(([k, v]) => {
          res.datasets[0].data.push(v.avg_time)
          res.datasets[1].data.push(v.failed)
          res.datasets[2].data.push(v.succeeded)
          res.labels.push(k)
        })
        commit('setDataTiktok', res)
      })
      .catch(e => console.log(e))
  },
  getDataTiktokMore ({ commit }, limit) {
    return axios
      .get(
        `https://api.feedpixel.com/v1/get-last-requests/?per_page=${limit}`,
        {
          auth: {
            username: 'feedpixel',
            password: '8ek[}L"Q=;#h&SY]',
          },
        },
      )
      .then(({ data }) => {
        commit('setDataTiktokMore', data.requests)
      })
  },
}
export default {
  state,
  mutations,
  actions,
}

// https://api.feedpixel.com/v1/statistics/?start_date=2021-04-16&end_date=2021-06-04
